import {returnParsedColumnName} from "../../utils/columns";

const CopyJsonToClipboard = rows => {
	const textarea = document.createElement('textarea');
	textarea.style.position = 'absolute';
	textarea.style.left = '-9999px';
	const headers = Object.keys(rows[0]).map(header => returnParsedColumnName(header));

	const csvData = rows.map((row) => Object.values(row));
	csvData.unshift(headers);
	const csvString = csvData.map((row) => row.join('\t')).join('\n');
	textarea.value = csvString;
	document.body.appendChild(textarea);
	textarea.select();
	document.execCommand('copy');
	document.body.removeChild(textarea);
};

export default CopyJsonToClipboard;